module.exports = __webpack_public_path__ + "img/@logo_ikea@3x.3af7e330.png";